import { FvButton } from '@fv/client-components'

import { useRouteGuideView } from '@/features/route-guides/hooks'
import { RouteGuideOverview } from '@/features/route-guides/RouteGuideOverview'

import { SliderContentHeader } from './SliderContentLayout'
import type { ShipmentContentProps } from './types'

export const RouteGuidePanel = ({
  load,
  setActiveSlider,
}: ShipmentContentProps) => {
  const view = useRouteGuideView(load)

  return (
    <RouteGuideOverview
      load={load}
      view={view}
      header={<SliderContentHeader {...load} prefix="Route guide for" />}
      onSkipped={() => setActiveSlider('quotes')}
      footerActions={
        <FvButton
          icon="times"
          theme="plain"
          onClick={() => setActiveSlider(undefined)}
        >
          Close
        </FvButton>
      }
    />
  )
}
